import WzCaseDecisionService from "@/services/WzCaseDecisionService";

export const namespaced = true;

const getDefaultState = () => {
    return {
        wz5_form: {
            case_guid: null,
            ip: null,
            decision: null,
            decision_message: null,
            order_number: null,
            with_parts_back: false,
            payment_type: null, //'cash_on_delivery'
            payment_operator : null, //'P24'
            immediate_consent: true,
            wz_costs_selected: null
        },

        payment_redirect_url: null,

        loading: false,
        error: false,
    }
}

export const state = getDefaultState();

export const mutations = {
    SET_WZ5_FORM(state, wz5_form) {
        state.wz5_form = wz5_form;
    },
    UPDATE_WZ5_FORM(state, payload) {
        state.wz5_form[payload.key] = payload.value;
    },
    SYNC_WZ5_FORM_FIELD_VALUES(state, payload) {
        if (state.wz5_form[payload.key].includes(payload.value)) {
            state.wz5_form[payload.key] = state.wz5_form[payload.key].filter(function (value) {
                if (value !== payload.value)
                    return value;
            });
        } else {
            state.wz5_form[payload.key].push(payload.value)
        }
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
};

export const actions = {
    setWz5Form({commit}, wz5_form) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", false);
        commit("SET_WZ5_FORM", wz5_form);
        commit("SET_LOADING", false);
    },
    updateWz5Form({commit}, payload) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", false);
        commit("UPDATE_WZ5_FORM", payload);
        commit("SET_LOADING", false);
    },
    syncValue({commit}, payload) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", false);
        commit("SYNC_WZ5_FORM_FIELD_VALUES", payload);
        commit("SET_LOADING", false);
    },
    storeWzCaseDecision({commit, state}) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", false);
        console.log(state);
        return WzCaseDecisionService.store({
            ...state.wz5_form
        }).then(() => {
                return true;
        }).catch(() => {
            commit("SET_ERROR", true);
            return false;
        }).finally(() => {
            setTimeout((function () {
                commit("SET_LOADING", false);
            }).bind(this), 600);
        });
    },
};

export const getters = {
    wz5_form: (state) => {
        return state.wz5_form;
    },
    loading: (state) => {
        return state.loading;
    },
    error: (state) => {
        return state.error;
    },
};